import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/header.css";
import "../css/main.css";
import navbarIcon from "../public/navbar/navbar-icon.png";
import navbarAccount from "../public/navbar/account.png";
import darkIcon from "../public/navbar/darkIcon.png";
import lightIcon from "../public/navbar/lightIcon.png";

import rightIcon from "../public/navbar/right.svg";
import rightIcon_Second from "../public/navbar/right_second.svg";

import { useContext } from "react";
import { DarkModeContext } from "./DarkModeProvider";

import { useAuth } from "../firebase";

const Navbar = () => {
  const { darkMode, setDarkMode } = useContext(DarkModeContext);
  const [isOpen, setIsOpen] = useState(false);

  const [photoURL, setPhotoURL] = useState("");

  const toggleHeader = () => {
    const menu = document.querySelector('.menu');
    const menuShow = document.querySelector('.nav ul')

    menu.classList.toggle('active');
    setTimeout(() => {
      menuShow.classList.toggle('active');
    }, 200);

  }


  // const toggleHeader = (e) => {
  //   const menu_btn = document.querySelector(".hamburger");
  //   const mobile_menu = document.querySelector(".mobile-nav");
  //   const body = document.querySelector("body");
  //   const mediaQuery = window.matchMedia("(max-width: 769px)");

  //   if (mediaQuery.matches) {
  //     mobile_menu.classList.add("animate__fadeOutDownBig");
  //     mobile_menu.classList.toggle("animate__fadeOutDownBig");
  //   }

  //   menu_btn.classList.toggle("is-active");
  //   setTimeout(() => {
  //     mobile_menu.classList.toggle("is-active");
  //   }, 200);
  //   body.classList.toggle("overflow");
  //   mobile_menu.classList.toggle("animate__fadeInUpBig");
  // };

  const CloseMenu = () => {
    const menu_btn = document.querySelector(".hamburger");
    const mobile_menu = document.querySelector(".mobile-nav");
    const body = document.querySelector("body");
    const mediaQuery = window.matchMedia("(max-width: 769px)");

    if (mediaQuery.matches) {
      mobile_menu.classList.remove("animate__fadeOutDownBig");
      mobile_menu.classList.remove("animate__fadeInUpBig");
      menu_btn.classList.remove("is-active");
      mobile_menu.classList.toggle("is-active");
      body.classList.remove("overflow");
    }
  };

  const DropdownMenu = (e) => {
    const mediaQuery = window.matchMedia("(max-width: 769px)");
    const dropdown = document.querySelector(".dropdown__content");

    if (mediaQuery.matches) {
      dropdown.classList.toggle("block");
      setIsOpen(!isOpen);
    }
  };


  const currentUser = useAuth();

  useEffect(() => {
    if (currentUser?.photoURL) {
      setPhotoURL(currentUser.photoURL)
    }
  }, [currentUser])

  return (
    <>
      <header className={darkMode ? "navbar dark" : "navbar light"}>
        <div className="container">
          <div className="list__container menu">
            <div className="navbar__container">
              <Link to="/">
                <img className="nav__img" src={navbarIcon} alt="Navbar Icon" />
              </Link>
              <Link className="navbar__link" to="/">
                <div className="navbar__text">
                  <h2 className={darkMode ? " dark-text" : " light-text"}>
                    České
                  </h2>
                  <p>Pohoří</p>
                </div>
              </Link>
            </div>
            <nav className="nav">
            <ul className={darkMode ? 'list mobile-nav dark  ' : 'list mobile-nav light '}>
              <li className="list__items list__items--dark">
                <div
                  onClick={DropdownMenu}
                  className={
                    darkMode
                      ? "list__text  dark-text"
                      : "list__text  light-text"
                  }
                >
                  Naše Pohoří
                  <img
                    src={isOpen ? rightIcon_Second : rightIcon}
                    alt="right icon"
                  />
                </div>
                <div
                  className={
                    darkMode
                      ? "dropdown__content dark"
                      : "dropdown__content light"
                  }
                >
                  <div className="dropdown__container">
                    <Link onClick={CloseMenu}
                      className={darkMode ? " dark-text" : " light-text"}
                      to="/beskydy"
                    >
                      ⛰️ Beskydy
                    </Link>
                    <Link onClick={CloseMenu}
                      className={darkMode ? " dark-text" : " light-text"}
                      to="/jeseniky"
                    >
                      ⛰️ Jeseníky
                    </Link>
                    <Link onClick={CloseMenu}
                      className={darkMode ? " dark-text" : " light-text"}
                      to="/krkonose"
                    >
                      ⛰️ Krkonoše
                    </Link>
                    <Link onClick={CloseMenu}
                      className={darkMode ? " dark-text" : " light-text"}
                      to="/sumava"
                    >
                      ⛰️ Šumava
                    </Link>
                  </div>
                </div>
              </li>

              <li className="list__items">
                <Link 
                  onClick={CloseMenu}
                  className={
                    darkMode ? "list__text dark-text" : "list__text light-text"
                  }
                  to="/jaksesbalitnahory"
                >
                  Jak se sbalit na hory
                </Link>
              </li>

              <li className="list__items">
                <Link
                  onClick={CloseMenu}
                  className={
                    darkMode ? "list__text dark-text" : "list__text light-text"
                  }
                  to="/kontakt"
                >
                  Kontakt
                </Link>
              </li>
            </ul>
            </nav>
            <div className="list__avatar">
              <div onClick={() => setDarkMode(!darkMode)}>
                <img src={darkMode ? lightIcon : darkIcon} alt="Dark Mode" />
              </div>
                  <Link to="/profile">
                  {photoURL ?  <img className="account" src={photoURL} alt="" /> :  <img src={navbarAccount} alt="" />}
                  </Link>
            </div>

            <div onClick={toggleHeader} className={darkMode ? ' nav-tgl darker' : ' nav-tgl '}>
              <span></span>
            </div>


      
          </div>

        </div>
      </header>

    </>
  );
};

export default Navbar;
